import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ProductDetailsContext } from '../../context';
import { messages } from './messages';
import style from './style.module.less';

export const AddVariantWarningModal = ({ onCloseModal, onConfirm }) => {
  const { productSku } = useContext(ProductDetailsContext);
  return (
    <Modal>
      <ModalHeader closeModal={onCloseModal}>
        <FormattedMessage {...messages.variantWarningConfirm} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div>
          <FormattedMessage {...messages.addVariantWarningBody} />
        </div>
        <div className={style['product-sku']}>{productSku}</div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={onCloseModal} theme='tertiary'>
          <FormattedMessage {...messages.variantWarningCancel} />
        </Button>
        <Button onClick={onConfirm} theme='primary'>
          <FormattedMessage {...messages.variantWarningConfirm} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddVariantWarningModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
